/* eslint-disable max-len */
import React, { Component } from 'react';
import { shape, string, func } from 'prop-types';

import { withAnalyticsHOC } from 'Scenes/_root/analyticsContext';
import { withMeetingContext, MeetingContextMeetingControlsProps } from 'Scenes/_root/meetingContext';
import { withAppContextHOC } from 'Scenes/_root/appContext';
import { ChimeMeetingProps, ChimeAttendeeProps } from 'Services/constants/meetings';
import MeetingPreview from './MeetingPreview';
import MeetingActive from './MeetingActive';

class Meeting extends Component {
  constructor(props) {
    super(props);
    if (props.meeting) {
      this.startMeeting();
    }
    this.state = {
      isMeetingActive: false,
    };
    this.deregisterMeetingCallbacks = props.registerMeetingCallbacks('meeting', {
      onMeetingAudioVideoDidStart: this.onMeetingAudioVideoDidStart,
      onMeetingAudioVideoDidStop: this.onMeetingAudioVideoDidStop,
      onMeetingEnd: this.onMeetingEnd,
    });
  }

  componentWillUnmount() {
    this.deregisterMeetingCallbacks();
  }

  componentDidUpdate(prevProps) {
    const {
      meeting,
    } = this.props;
    if (prevProps.meeting !== meeting) {
      this.startMeeting();
    }
  }

  startMeeting = () => {
    const {
      meeting,
      attendee,
      identityEmail,
      meetingControls,
    } = this.props;
    if (meeting) {
      meetingControls.start(meeting, attendee, identityEmail);
    }
  }

  onMeetingAudioVideoDidStop = (meetingSessionStatusCode) => {
    const {
      meetingControls,
      trackEvent,
    } = this.props;
    if (
      meetingSessionStatusCode.isAudioConnectionFailure() ||
      meetingSessionStatusCode.isFailure() ||
      meetingSessionStatusCode.isTerminal()
    ) { // meeting ended
      trackEvent('meeting ended', {
        reasonCode: meetingSessionStatusCode,
        audioConnectionFailure: meetingSessionStatusCode.isAudioConnectionFailure(),
        isFailure: meetingSessionStatusCode.isFailure(),
        isTerminal: meetingSessionStatusCode.isTerminal(),
      });
      window.console.log(
        '[meeting] meeting ended due to status code',
        meetingSessionStatusCode.statusCode(),
        meetingSessionStatusCode.isAudioConnectionFailure(),
        meetingSessionStatusCode.isFailure(),
        meetingSessionStatusCode.isTerminal(),
      );
      meetingControls.stop();
    }
  }

  onMeetingAudioVideoDidStart = () => {
    this.setState({
      isMeetingActive: true,
    });
  }

  onMeetingEnd = () => {
    this.setState({
      isMeetingActive: false,
    });
  }

  render() {
    const { isMeetingActive } = this.state;

    if (!isMeetingActive) {
      return <MeetingPreview />;
    }

    return (
      <MeetingActive />
    );
  }
}

const MapStateProps = {
  meeting: shape(ChimeMeetingProps),
  attendee: shape(ChimeAttendeeProps),
};

Meeting.propTypes = {
  registerMeetingCallbacks: func.isRequired,
  meetingControls: MeetingContextMeetingControlsProps,
  trackEvent: func.isRequired,
  identityEmail: string,
  ...MapStateProps,
};

export default withAnalyticsHOC()(withMeetingContext([
  'registerMeetingCallbacks',
  'meetingControls',
])(withAppContextHOC(['identityEmail'])(Meeting)));
